import { getAssetBaseUrl } from '@/utils/utils';

const isStorageAccessError = (error: unknown) => {
  const message = error instanceof Error ? error.message : String(error ?? '');
  return error instanceof DOMException && error.name === 'AbortError' && message.includes('Failed to access storage');
};

const handleServiceWorkerError = (error: unknown) => {
  if (isStorageAccessError(error)) return;
  console.warn('model-cache service worker registration failed', error);
};

export const setupServiceWorker = async () => {
  const baseUrl = getAssetBaseUrl();

  if (!('serviceWorker' in navigator)) return;

  try {
    const registration = await navigator.serviceWorker.register(baseUrl + '/model-cache.js', {
      scope: baseUrl + '/',
      updateViaCache: 'none',
    });

    await registration.update();
  } catch (error) {
    handleServiceWorkerError(error);
  }
};
